import React, { useState } from "react"
import styled from "styled-components"
import ReactHtmlParser from 'react-html-parser';
import ReactMarkdown from 'react-markdown';
import _ from "lodash";

var Container = styled.div`
  color: #000000;
  padding-top: 20px;
  padding-bottom: ${props => props.onlyDesc ? "20px" : "0px"};
  & img{
    width: 100%;
    height: auto;
  }
  & img[alt*="DESKTOP"]{
    display: none;
  }

  & img[alt*="MOBILE"]{
    display: block;
  }
  @media only screen and (min-width: 768px) {
    & img[alt*="DESKTOP"]{
      display: block;
    }

    & img[alt*="MOBILE"]{
      display: none;
    }
  }
`
var Title_Content = styled.h2`
  color: #333333;
  margin-top: 0;
  margin-left:8px;
`
var Content_Desc = styled.div`
  padding: 0px 10px;
  text-align:justify;
  padding-left: ${props => props.onlyDesc ? "0px" : "10px"};
  & td{
    vertical-align: baseline;
    text-align: left;
  }
  & colgroup{
    & col:first-child{
      width: 50% !important;
      @media (min-width: 768px) {
        width: 20% !important;
      }
    }
    & col:nth-child(2){
      width: 100%;
    }
  }

  // & table{
  //   width: 100%;
  //   & tr{
  //     display: flex;
  //     width: 100%;
  //     & td:first-child{
  //       width: 100%;
  //       display: flex;
  //     }
  //     & td:nth-child(2){
  //       width: 100%;
  //       display: flex;
  //     }
  //   }
  // }
`
var Content_Desc2 = styled.div`
  padding: 0px 10px;
  margin-top: -15px;
  text-align:justify;
`
var LinkWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`
var SpanMore = styled(LinkWrapper)`
  display: ${props => (props.block ? "flex" : "none")};
`
var Span = styled.span`
  width: 100%;
  display: ${props => (props.block ? "none" : "block")};
  margin: 10px;
  color: red;
  cursor: pointer;
  &:hover {
    color: #950000;
  }
`

export default function MaintitleDesc(props) {
  var [Toggle, SetToggle] = useState(false);
  const {isMarkdown = false} = props;
  const parser = isMarkdown ? (chil) => <ReactMarkdown linkTarget="_blank">{chil}</ReactMarkdown> : (chil) => ReactHtmlParser(chil);
  const [onlyDesc] = useState(()=>{
    let isTitleEmpty = _.isEmpty(props?.title);
    return isTitleEmpty ? true : false;
  })
  const keywords = props.keywords

  const formatText = (text, keywords) => {
    let newText = text;
    for(const keyword in keywords){
        newText = newText.replace(`{{${keyword}}}`, keywords[keyword]);
    }
    return newText;
  }
  let content = props.keywords?formatText(props.description,keywords):props.description
  return props.title || content ? (
    <Container style={{listStyle: "disc"}} onlyDesc={onlyDesc}>
      {props.title ? <Title_Content>{props.title}</Title_Content> : null}
      {content ? (
        <Content_Desc onlyDesc={onlyDesc}>
          {Array.isArray(content) ? (
            content
              .slice(0, 2)
              .map((x, index) => (
                <p key={"maintitleDescription" + index}>{ parser(x)}</p>
              ))
          ) : (
            <p>{parser(content)}</p>
          )}
        </Content_Desc>
      ) : null}
      {Array.isArray(content) && content.length > 2 ? (
        <>
          <Span onClick={() => SetToggle(true)} block={Toggle}>
            Read More...
          </Span>
          <SpanMore block={Toggle}>
            <Content_Desc2>
              {content.slice(2).map((x, index) => (
                <p key={"maintitleDesc" + index}>{parser(x)}</p>
              ))}
            </Content_Desc2>
            <Span onClick={() => SetToggle(false)}>Read Less...</Span>
          </SpanMore>
        </>
      ) : null}
    </Container>
  ) : null
}
